











import { Vue, Component, Prop } from 'vue-property-decorator';
import Button from '@/components/Controls/Button/Button.vue';

@Component({
    components: {
        Button,
    },
})
export default class ScrollLineItem extends Vue {
    /**
     *
     */
    @Prop()
    public readonly active!: boolean;
    /**
     *
     */
    @Prop()
    public readonly loading!: boolean;
}
